export const SeriesAvailability = {
  PUBLIC: 'PUBLIC',
  FOLLOWER: 'ONLY_FOLLOWERS',
  MUTUAL_FOLLOWER: 'ONLY_MUTUAL_FOLLOW',
} as const;
export type SeriesAvailability =
  typeof SeriesAvailability[keyof typeof SeriesAvailability];
